
<div class="containerpadding">
 
  <div class="row d-flex justify-content-between">
    <div class="col-sm-11 col-12">
      <div class="card">
        <div class="card-header backgrund-green">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <mat-icon aria-hidden="false" aria-label="Prijave kvara">task_alt</mat-icon> Prijava kvara <span *ngIf="lista">{{lista.length}}</span>
            </div>            
          </div>
        </div>
       
        <ul *ngIf="lista" class="list-group list-group-flush">
          <li class="list-group-item" *ngFor="let zahtjev of lista">
            <mat-card-content>
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5 class="requesttitle">{{zahtjev.datum | date: 'dd.MM.yyyy'}} inkasator:{{zahtjev.inkasator}}</h5>
              </div>
              <div class="col-12 mt-1">
                <h4 class="card-subtitle mb-2  requeststatus"> {{zahtjev.opis}}</h4><br />
              </div>
              <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel (opened)="UcitajSliku(zahtjev)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Fotografija
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngIf="zahtjev.image==''">
                    Učitavam sliku, malo će potrajati...
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                  <app-prikaz-slike [image]="zahtjev.image"></app-prikaz-slike>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-card-content>
            <mat-card-actions>
             
            </mat-card-actions>
          </li>
        </ul>
      </div>
    </div>    
  </div>
</div>
